import LoadingPage from "components/LoadingPage";
import { lazy, Suspense } from "react";

const Marketing = lazy(() => import("pages/Marketing"));

const CampanhaPesquisa = lazy(() => import("pages/Marketing/CampanhaPesquisa"));
const CampanhaDisplay = lazy(() => import("pages/Marketing/CampanhaDisplay"));
const CampanhaShopping = lazy(() => import("pages/Marketing/CampanhaShopping"));
const CampanhaVideo = lazy(() => import("pages/Marketing/CampanhaVideo"));
const CampanhaAplicativo = lazy(
  () => import("pages/Marketing/CampanhaAplicativo")
);
const CampanhaLocal = lazy(() => import("pages/Marketing/CampanhaLocal"));
const CampanhaPerformanceMax = lazy(
  () => import("pages/Marketing/CampanhaPerformanceMax")
);
const CampanhaDiscovery = lazy(
  () => import("pages/Marketing/CampanhaDiscovery")
);
const CampanhaInteligente = lazy(
  () => import("pages/Marketing/CampanhaInteligente")
);
const CampanhaRemarketing = lazy(
  () => import("pages/Marketing/CampanhaRemarketing")
);
const CampanhaCallOnly = lazy(() => import("pages/Marketing/CampanhaCallOnly"));

const CampanhaDisplayDinamico = lazy(
  () => import("pages/Marketing/CampanhaDisplayDinamico")
);
const OtimizacaoSEO = lazy(() => import("pages/Marketing/OtimizacaoSEO"));
const FacebookADS = lazy(() => import("pages/Marketing/FacebookADS"));
const InstagramADS = lazy(() => import("pages/Marketing/InstagramADS"));
const LinkedinADS = lazy(() => import("pages/Marketing/LinkedinADS"));
const TikTokADS = lazy(() => import("pages/Marketing/TikTokADS"));
// const EmailMarketing = lazy(() => import("pages/Marketing/EmailMarketing"));

const useRoutersMarketing = () => {
  return [
    {
      path: "/marketing",
      element: (
        <Suspense fallback={<LoadingPage />}>
          <Marketing />
        </Suspense>
      ),
    },
    {
      path: "/marketing/campanha-de-pesquisa",
      element: (
        <Suspense fallback={<LoadingPage />}>
          <CampanhaPesquisa />
        </Suspense>
      ),
    },
    {
      path: "/marketing/campanha-de-display",
      element: (
        <Suspense fallback={<LoadingPage />}>
          <CampanhaDisplay />
        </Suspense>
      ),
    },
    {
      path: "/marketing/campanha-de-shopping",
      element: (
        <Suspense fallback={<LoadingPage />}>
          <CampanhaShopping />
        </Suspense>
      ),
    },
    {
      path: "/marketing/campanha-de-video",
      element: (
        <Suspense fallback={<LoadingPage />}>
          <CampanhaVideo />
        </Suspense>
      ),
    },
    {
      path: "/marketing/campanha-de-aplicativo",
      element: (
        <Suspense fallback={<LoadingPage />}>
          <CampanhaAplicativo />
        </Suspense>
      ),
    },
    {
      path: "/marketing/campanha-local",
      element: (
        <Suspense fallback={<LoadingPage />}>
          <CampanhaLocal />
        </Suspense>
      ),
    },
    {
      path: "/marketing/campanha-performance-max",
      element: (
        <Suspense fallback={<LoadingPage />}>
          <CampanhaPerformanceMax />
        </Suspense>
      ),
    },
    {
      path: "/marketing/campanha-discovery",
      element: (
        <Suspense fallback={<LoadingPage />}>
          <CampanhaDiscovery />
        </Suspense>
      ),
    },
    {
      path: "/marketing/campanha-inteligente",
      element: (
        <Suspense fallback={<LoadingPage />}>
          <CampanhaInteligente />
        </Suspense>
      ),
    },
    {
      path: "/marketing/campanha-remarketing",
      element: (
        <Suspense fallback={<LoadingPage />}>
          <CampanhaRemarketing />
        </Suspense>
      ),
    },
    {
      path: "/marketing/campanha-call-only",
      element: (
        <Suspense fallback={<LoadingPage />}>
          <CampanhaCallOnly />
        </Suspense>
      ),
    },
    {
      path: "/marketing/campanha-display-dinamico",
      element: (
        <Suspense fallback={<LoadingPage />}>
          <CampanhaDisplayDinamico />
        </Suspense>
      ),
    },
    {
      path: "/marketing/seo",
      element: (
        <Suspense fallback={<LoadingPage />}>
          <OtimizacaoSEO />
        </Suspense>
      ),
    },
    {
      path: "/marketing/facebook-ads",
      element: (
        <Suspense fallback={<LoadingPage />}>
          <FacebookADS />
        </Suspense>
      ),
    },
    {
      path: "/marketing/instagram-ads",
      element: (
        <Suspense fallback={<LoadingPage />}>
          <InstagramADS />
        </Suspense>
      ),
    },
    {
      path: "/marketing/linkedin-ads",
      element: (
        <Suspense fallback={<LoadingPage />}>
          <LinkedinADS />
        </Suspense>
      ),
    },
    {
      path: "/marketing/tiktok-ads",
      element: (
        <Suspense fallback={<LoadingPage />}>
          <TikTokADS />
        </Suspense>
      ),
    },
    // {
    //   path: "/marketing/email-marketing",
    //   element: (
    //     <Suspense fallback={<LoadingPage />}>
    //       <EmailMarketing />
    //     </Suspense>
    //   ),
    // },
  ];
};

export default useRoutersMarketing;
